import {
  Component,
  OnInit,
  Input,
  EventEmitter,
  Output,
  ViewEncapsulation,
  SimpleChanges,
} from "@angular/core";
import { Store } from "@ngrx/store";
import { ChartFilters } from "src/app/store/models/charts-page.model";
import { AppState, stateGetter } from "src/app/store/state/app.state";

@Component({
  selector: "app-charts-filters",
  templateUrl: "./charts-filters.component.html",
  styleUrls: ["./charts-filters.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class ChartsFiltersComponent implements OnInit {
  scale: string;
  yearFilterDisplayType = "Dual";
  chartType;
  selectedCurrency: string;
  selectedRevision: string;
  selectedScaleType: string;
  scaleTypeList: Array<any>;
  selectedEstimates: Array<string>;
  selectedDataView: string;
  dataViewList: Array<any>;
  yearType: any;
  tsYearType: any;
  apiEP: string = window.apiUrl;

  @Input() periodsWithAvailableData;
  @Input() metaReady: boolean;
  @Input() filterData: {
    allPeriods: Array<number>;
    yearType: {};
    dataView: Array<any>;
  };
  @Input() chartTypeId: number;
  @Input() currencyOptionList: Array<any> = [
    { iso_currency: "USD", symbol: "$" },
    { iso_currency: "EUR", symbol: "$" },
    { iso_currency: "JPY", symbol: "$" },
  ];

  @Output() onCurrencyFilterChange = new EventEmitter();
  @Output() onScaleTypeFilterChange = new EventEmitter();
  @Output() onDataViewFilterChange = new EventEmitter();
  @Output() onEstimatesFilterChange = new EventEmitter();
  @Output() onRevisionFilterChange = new EventEmitter();
  @Output() saveYearType = new EventEmitter();
  @Output() setPeriod = new EventEmitter();

  constructor(private store: Store<AppState>) {}

  ngOnInit() {
    this.scaleTypeList = [
      { key: "Absolute", value: "Absolute" },
      { key: "Index to 100", value: "Index" },
    ];
    this.dataViewList = [
      { key: "Values", value: "value" },
      { key: "YoY%", value: "yoy" },
    ];

    this.store
      .select(stateGetter("chartsPage", "chartMeta", "filters"))
      .subscribe((filter: ChartFilters) => {
        this.selectedCurrency = filter.currency;
        this.selectedRevision = filter.revisionPeriod;
        this.selectedScaleType = filter.scaleType;
        this.selectedEstimates = filter.periods;
        this.selectedDataView = filter.dataView;
        this.yearType = filter.yearType;
        this.tsYearType = filter.tsYearType;
      });
  }

  ngOnChanges(changes: SimpleChanges) {
    // if(changes.tsYearType && changes.tsYearType.currentValue !== changes.tsYearType.previousValue){
    //   this.tsYearType = changes.tsYearType.currentValue;
    // }
    if (changes.chartTypeId && changes.chartTypeId.currentValue) {
      if (this.chartTypeId === 1) {
        this.chartType = "normalChart";
      } else if (this.chartTypeId === 2) {
        this.chartType = "TimeSeries";
      }
    }
  }

  onScaleTypeChange(params) {
    this.onScaleTypeFilterChange.emit(params);
  }

  onChangeEstimates(params) {
    this.onEstimatesFilterChange.emit(params);
  }

  onRevisionChange(newRevision: string) {
    this.onRevisionFilterChange.emit(newRevision);
  }

  onDataViewChange(newDataView) {
    this.onDataViewFilterChange.emit(newDataView);
  }

  setCompsPeriod(param) {
    console.error(param);
  }

  saveChartsYearType(param) {
    this.saveYearType.emit(param);
  }

  onCurrencyChange(newCurrency: string) {
    this.onCurrencyFilterChange.emit(newCurrency);
  }
}
